import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ElectorateMapV2 } from '../components/shared/ElectorateMapV2';
import { MapHoverProvider } from '../components/shared/MapHoverContext';
import type { ShireId } from '../components/shared/electorate-shires';

/**
 * Sandbox route that mounts ElectorateMapV2 in isolation. Used by the
 * `electorate-v2` Playwright suite — keep the page minimal (no header chrome,
 * no Common Tasks strip) so testids and keyboard semantics aren't masked.
 *
 * `?debug=1` is read inside the map and opens the debug overlay.
 */
export const Route = createFileRoute('/learn/electorate-v2')({
  head: () => ({
    meta: [
      { title: 'ElectorateMapV2 sandbox — Warren-Blackwood' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
  component: ElectorateV2Sandbox,
});

function ElectorateV2Sandbox() {
  const [shire, setShire] = useState<ShireId | null>(null);
  const [locality, setLocality] = useState<string | null>(null);

  return (
    <main
      id="main-content"
      style={{
        maxWidth: 960,
        margin: '0 auto',
        padding: 'var(--sp-md)',
      }}
    >
      <h1
        style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '1.4rem',
          color: 'var(--green)',
          margin: '0 0 var(--sp-sm)',
        }}
      >
        ElectorateMapV2 sandbox
      </h1>
      <p style={{ color: 'var(--ink-mid)', margin: '0 0 var(--sp-md)', fontSize: '0.9rem' }}>
        Test-only mount. Append <code>?debug=1</code> to expose the debug overlay.
      </p>
      <MapHoverProvider>
        <ElectorateMapV2
          shireId={shire}
          locality={locality}
          onShireChange={(id) => {
            setShire(id);
            if (!id) setLocality(null);
          }}
          onLocalityChange={setLocality}
        />
      </MapHoverProvider>
    </main>
  );
}
